export default __webpack_public_path__ + "static/heathwood-164242b2ff730de25d09d66027d76dab.png";